import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=4bf980fc&scoped=true&"
import script from "./TOS.vue?vue&type=script&lang=ts&"
export * from "./TOS.vue?vue&type=script&lang=ts&"
import style0 from "./TOS.vue?vue&type=style&index=0&id=4bf980fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf980fc",
  null
  
)

export default component.exports